import { z } from "zod";

export enum CommunityStatus {
  pending = "pending",
  active = "active",
  launched = "launched",
}

export const communityStatusEnum = z.nativeEnum(CommunityStatus);
